export default class SphinxArchiveInner {
  constructor() {
    this.selector = '.b-sphinx-archive-inner';

    this.selectors = {
      iframe: '.b-sphinx-archive-inner__iframe',
      categorySelect: '.b-sphinx-archive-inner__filter-category-select',
    };
  }

  bootstrap() {
    const page = document.querySelector(this.selector);

    if (!page) {
      return;
    }

    const categorySelect = document.querySelector(
      this.selectors.categorySelect,
    );

    if (categorySelect) {
      categorySelect.addEventListener('change', event => {
        const { value } = event.target;

        location.href = value;
      });
    }

    const iframe = document.querySelector(this.selectors.iframe);

    window.addEventListener(
      'message',
      event => {
        const message = event.data;

        if (message.height) {
          iframe.style.height = `${message.height + 60}px`;
        }

        if (message.scrollTop) {
          jQuery('html, body').animate(
            {
              scrollTop:
                message.scrollTop + jQuery('#content-wrap').offset().top - 30,
            },
            1000,
          );
        }

        if (message.linkOpen) {
          window.open(message.linkOpen, '_blank');
        }

        if (message.setReferrerLink) {
          let refLink = message.setReferrerLink;

          if (refLink[0] === '#') {
            const currUrl = location.search;
            const thisDocUrl = window.location.href.split('?')[0];

            refLink = thisDocUrl + currUrl + refLink;
          }

          history.pushState({}, 'Sphinx Documentation', refLink);

          const url = refLink;
          const urlParam = url.slice(Math.max(0, url.indexOf('?')));

          jQuery('#referrer_param').val(urlParam);
        }
      },
      false,
    );
  }
}
